/**
 * Agent ID constants
 * Centralized constants for agent identifiers used across the application
 */
export const AGENT_IDS = {
  DIFOT: 'difot',
  WHUTIL: 'whutil',
  ARI: 'ari',
  SHAREPOINT: 'sharepoint',
  PPL: 'ppl',
  GENERIC: 'generic',
  WEBSEARCH: 'websearch',
  IMAGE: 'image',
  M365: 'm365',
  CODE_INTERPRETER: 'codeinterpreter',
  FUNCTIONAL_SPEC: 'functionalspec',
  ASSET_MANAGEMENT: 'assetmanagement',
  DIGITAL_MAINTENANCE: 'digitalmaintenance',
  TRANSPORT: 'transport',
} as const;

export const GENIE_SPACE_AGENT_IDS = [
  AGENT_IDS.DIFOT,
  AGENT_IDS.WHUTIL,
  AGENT_IDS.ARI,
  AGENT_IDS.SHAREPOINT,
] as const;

/**
 * Type for agent IDs
 */
export type AgentId = typeof AGENT_IDS[keyof typeof AGENT_IDS];
